var getFieldId = function getFieldId(props, state, createId) {
  return props.id || state.id || createId();
};

export default getFieldId;
//# sourceMappingURL=get-field-id.js.map
